module.exports = __webpack_public_path__ + "img/icon_map_101_off.9d0d599d.png";